export default __webpack_public_path__ + "static/SRF 4400ACS10 - Product Specifications & Technical Data-5e07e712c9fbb387e32fb3d4ffbf8292.pdf";